function displayErrorBlock(title, message, icon = "warning") {
    $("#form-container").addClass("hidden");
    $("#error-container").removeClass("hidden");
    $("#error-container h1").html(title);
    $("#error-container p[data-message]").html(message);
    $("#error-container .error-icon svg").hide();
    $("#error-container .error-icon svg[data-icon='" + icon + "']").show();
}

function displayUnauthorizedPage() {
    displayErrorBlock("Access Restricted", "You are not allowed to view this page.", "lock");
}

function displayAlreadyReported(message, title = "No Action Available") {
    displayErrorBlock(title, message, "warning");
}

function displayNotFound(message, title = "Not Found") {
    displayErrorBlock(title, message, "cancel");
}

function displayTechnical() {
    displayErrorBlock("Technical Error", "A technical error occured, please contact us by email or phone to report your booking", "guard");
}